
import { defineComponent } from "vue";

export default defineComponent({
  name: "DisplayCertificate",
  data() {
    return {
      imageLink: "",
    };
  },
  props: {
    certificateFile: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDisplayCertificateModal");
    },
    async getImage(): Promise<string> {
      if (!this.certificateFile) return "";
      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/static/${this.certificateFile}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.$store.getters["auth/getAccessToken"]}`,
          },
        }
      );

      if (response.status === 200) {
        const url = URL.createObjectURL(await response.blob());
        return url;
      }
      return "";
    },
  },
  watch: {
    certificateFile() {
      this.getImage().then((url) => {
        this.imageLink = url;
      });
    },
  },
});
